import {RootState} from "../../../../store";

export const getProfileInfoById = (state: RootState) => state.profileInfoReducer.profileInfo;
export const getIsFromSpecialistPage = (state: RootState) => state.profileInfoReducer.isFromSpecialistPage;
